import React from 'react'
import CloseIcon from '../Icons/CloseIcon'

const Disclaimer = ({
  icon: Icon = CloseIcon,
  href ='',
  target = '_blank',
  disclaimerText = '',
  onClick,
  onPrivacyPolicyClick,
  className = '',
  disabled = false,
  visible = true,
  isPreviewMode = false,
  ...props
}) => {
  return (
    <div className="bubble-disclaimer flex items-center justify-between  bg-transparent rounded-b-v3-xl  gap-v3-xs font-inter-variable px-v3-sm py-[12px]  w-full ">
     <p className="text-v3-black-placeholder text-[12px] leading-16" dangerouslySetInnerHTML={{ __html: disclaimerText }}>
       
      </p>
         {!isPreviewMode && <Icon className="flex-shrink-0 text-v3-black-placeholder w-[16px] h-[16px] cursor-pointer" onClick={onClick} />}
     
    </div>
  )
}

export default Disclaimer